/* tslint:disable */
/* eslint-disable */
/**
 * Animare Management API
 * This API provides methods for viewing and modifying animare database data for authorities. 
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PossessorDto } from './PossessorDto';
import {
    PossessorDtoFromJSON,
    PossessorDtoFromJSONTyped,
    PossessorDtoToJSON,
} from './PossessorDto';

/**
 * Request for changing the possessor of the animal of a currently active registration.
 * @export
 * @interface PossessorChangeRequestDto
 */
export interface PossessorChangeRequestDto {
    /**
     * When the registration form has arrived (only for paper registration).
     * @type {Date}
     * @memberof PossessorChangeRequestDto
     */
    arrivalDate: Date;
    /**
     * 
     * @type {PossessorDto}
     * @memberof PossessorChangeRequestDto
     */
    newPossessor: PossessorDto;
    /**
     * When the animal has physically changed possessors.
     * @type {Date}
     * @memberof PossessorChangeRequestDto
     */
    transferDate: Date;
}

/**
 * Check if a given object implements the PossessorChangeRequestDto interface.
 */
export function instanceOfPossessorChangeRequestDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "arrivalDate" in value;
    isInstance = isInstance && "newPossessor" in value;
    isInstance = isInstance && "transferDate" in value;

    return isInstance;
}

export function PossessorChangeRequestDtoFromJSON(json: any): PossessorChangeRequestDto {
    return PossessorChangeRequestDtoFromJSONTyped(json, false);
}

export function PossessorChangeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossessorChangeRequestDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'arrivalDate': (new Date(json['arrivalDate'])),
        'newPossessor': PossessorDtoFromJSON(json['newPossessor']),
        'transferDate': (new Date(json['transferDate'])),
    };
}

export function PossessorChangeRequestDtoToJSON(value?: PossessorChangeRequestDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'arrivalDate': (value.arrivalDate.toISOString().substr(0,10)),
        'newPossessor': PossessorDtoToJSON(value.newPossessor),
        'transferDate': (value.transferDate.toISOString().substr(0,10)),
    };
}

